import { Navigate, Outlet, useSearchParams } from 'react-router-dom';

import { useWorkspacePlan } from '@/modules/billing/hooks/useWorkspacePlan';
import { HMLoadError } from '@/modules/hiring-manager/components/HMLoadError';
import { toSearchSuffix } from '@/modules/hiring-manager/utils/searchSuffix';
import Loader from '@/modules/ui/components/loader/Loader';

/** Guard direct links too, before restricted pages mount queries or mutations. */
export function SelfServiceRoute() {
  const { plan, isLoading, error } = useWorkspacePlan();
  const [searchParams] = useSearchParams();

  if (isLoading) return <Loader />;
  if (error) {
    return (
      <HMLoadError
        title="Workspace plan unavailable"
        description="We could not confirm your workspace plan. Please reload the page before managing jobs or messages."
      />
    );
  }
  if (plan === 'managed') {
    return <Navigate replace to={`/hm${toSearchSuffix(searchParams)}`} />;
  }
  return <Outlet />;
}
